export const loginTabs = () => {
  const headers = document.querySelectorAll('.loginPanel__loginTabsHeader');
  const tabs = document.querySelectorAll('.loginPanel__loginTab');

  const deleteActive = () => {
    headers.forEach( header => {
      (header.classList.contains('active')) ? header.classList.remove('active') : '';
    })
    tabs.forEach( tab => {
      (tab.classList.contains('active')) ? tab.classList.remove('active') : '';
    })
  }

  headers.forEach( header => {
    header.addEventListener('click', ()=>{
      const address = header.getAttribute('data-active');

      console.log(address);

      deleteActive();

      header.classList.add('active');

      tabs.forEach( tab => {
        (tab.getAttribute('data-active') == address) ? tab.classList.add('active') : '';
      })
    })
  })



}